import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';

import { SponsorLevelWithSponsors } from '@/entities/Sponsor';

interface SponsorsSectionProps {
	sponsorLevel: SponsorLevelWithSponsors;
	isSponsorsPage?: boolean;
}

export const SponsorsSection = ({ sponsorLevel, isSponsorsPage }: SponsorsSectionProps) => {
	return (
		<div className={`flex flex-col rounded-lg bg-white ${isSponsorsPage && 'p-8 flex-wrap'}`}>
			<div className={`rounded-t-lg text-lg font-bold text-darkorange-600 ${isSponsorsPage ? 'sm:text-2xl' : 'p-2 bg-darkorange-100'}`}>
				{sponsorLevel.sponsorLevelTitle}
			</div>

			<div className={`${isSponsorsPage ? 'flex flex-wrap gap-4' : 'grid grid-cols-2 gap-4 p-4 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2'}`}>
				{sponsorLevel.systemSponsors.map((sponsor) => (
					<div
						key={sponsor.uuid}
						className={`p-2 border border-gray-300 rounded-md ${isSponsorsPage ? 'max-w-[180px]  max-h-[180px]' : 'w-[132px] h-[132px]'}`}
					>
						{sponsor.url ? (
							<a href={sponsor.url} target="_blank" rel="noopener noreferrer">
								<img
									src={getCDNURL(sponsor.logoUrl, 250, 250)}
									alt={`${sponsor.title} logo`}
									className={`object-contain  bg-white ${isSponsorsPage ? 'max-w-[174px] max-h-[174px]' : 'w-[116px] h-[116px]'}`}
								/>
							</a>
						) : (
							<img
								src={getCDNURL(sponsor.logoUrl, 250, 250)}
								alt={`${sponsor.title} logo`}
								className={`object-contain  bg-white ${isSponsorsPage ? 'max-w-[174px] max-h-[174px]' : 'w-[116px] h-[116px]'}`}
							/>
						)}
					</div>
				))}
			</div>
		</div>
	);
};
